import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, MapPinIcon, ClipboardIcon, MessageIcon, CheckCircleIcon } from './Icons';
export function BonusSection() {
  return <section className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-52">
      <div className="max-w-2xl mx-auto" data-id="element-53">
        {/* Transition Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24" data-id="element-54">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown-dark text-center mb-6 md:mb-10" data-id="element-55">
            Pero eso no es todo.
          </h2>
          <div className="space-y-4 md:space-y-6 font-body text-lg text-brown-medium leading-relaxed" data-id="element-56">
            <p data-id="element-57">
              Porque sé exactamente lo que pasa cuando alguien descarga una guía
              y la deja en "pendientes":
            </p>
            <p className="font-semibold text-brown-dark italic" data-id="element-58">
              La vida interrumpe. El picor vuelve. Y el cepillo sigue
              llenándose.
            </p>
            <p data-id="element-59">Por eso quise asegurarme de que eso no te pase a ti.</p>
            <p data-id="element-60">
              Así que cuando te llevas Rescate Capilar 60+ hoy, no recibes solo
              el protocolo.
            </p>
            <p data-id="element-61">
              Recibes 3 herramientas extra diseñadas para que empieces hoy, no
              te pierdas en el camino y veas resultados antes de lo que esperas.
            </p>
            <p className="font-bold text-xl text-gold mt-6 text-center" data-id="element-62">
              Y todo esto… sin costo adicional.
            </p>
          </div>
        </motion.div>

        {/* Section Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-3xl md:text-4xl font-bold text-brown-dark text-center mb-10 md:mb-16" data-id="element-63">
          Tus 3 Bonos de Rescate{' '}
          <span className="text-gold block sm:inline" data-id="element-64">(Gratis hoy)</span>
        </motion.h2>

        <div className="space-y-12 md:space-y-16" data-id="element-65">
          {/* BONO #1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="bg-cream rounded-2xl p-6 md:p-10 border border-gold/20 shadow-lg shadow-gold/5 relative overflow-hidden" data-id="element-66">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -z-0" data-id="element-67" />

            <div className="relative z-10" data-id="element-68">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 rounded-full mb-6" data-id="element-69">
                <GiftIcon className="w-5 h-5 text-gold" data-id="element-70" />
                <span className="text-sm font-bold text-gold font-body tracking-wider uppercase" data-id="element-71">
                  Bono #1
                </span>
              </div>

              <div className="flex items-start gap-4 mb-6" data-id="element-72">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-sm border border-gold/10" data-id="element-73">
                  <MapPinIcon className="w-6 h-6 text-gold" data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <h3 className="font-heading text-2xl font-bold text-brown-dark mb-2" data-id="element-76">
                    "Mapa Express del Cuero Cabelludo™"
                  </h3>
                  <p className="font-body text-lg font-medium text-sage-dark" data-id="element-77">
                    Autodiagnóstico en 5 minutos + Plan Exacto
                  </p>
                </div>
              </div>

              {/* Image Mockup */}
              <div className="mb-8 flex justify-center" data-id="element-78">
                <img src="https://cdn.magicpatterns.com/uploads/oeWo1NrYXvAyqpYYkpCFSX/hf_20260321_140540_b13dfae9-ec18-47c5-b287-9b830cb7d882.jpg" alt="Mapa Express del Cuero Cabelludo — Autodiagnóstico en 5 minutos + Plan Exacto" className="w-full max-w-xs rounded-xl shadow-md border border-gold/10" data-id="element-79" />
              </div>

              <div className="space-y-4 font-body text-base text-brown-medium leading-relaxed mb-8" data-id="element-80">
                <p data-id="element-81">
                  Antes de aplicar cualquier protocolo, necesitas saber
                  exactamente qué está pasando en tu cuero cabelludo.
                </p>
                <p data-id="element-82">
                  ¿Dónde está el mayor picor? ¿Qué lo dispara? ¿Tu caso es leve,
                  medio o requiere calma urgente?
                </p>
                <p data-id="element-83">Este bono responde todo eso en 5 minutos.</p>
                <p data-id="element-84">
                  Con el Mapa por Zonas vas a identificar tus puntos críticos y
                  con el Semáforo de Acción (verde, amarillo, rojo) sabrás
                  exactamente qué protocolo seguir según tu nivel.
                </p>
                <p className="font-semibold text-brown-dark" data-id="element-85">
                  Sin adivinar. Sin improvisar. Sin perder tiempo probando cosas
                  que no son para ti.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gold/10 mb-8" data-id="element-86">
                <p className="font-heading text-lg font-bold text-brown-dark mb-4" data-id="element-87">
                  Lo que incluye:
                </p>
                <ul className="space-y-3" role="list" data-id="element-88">
                  {['Test "3 Señales" (picor, caída, sensibilidad)', 'Mapa por zonas para identificar "puntos calientes"', 'Semáforo de Acción con Plan "Hoy" según tu resultado', 'Top 10 disparadores para encontrar el culpable', 'Tracker de 7 días (1 minuto por día)', 'Plantilla printable para celular o papel'].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-89">
                      <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-90" />
                      <span className="font-body text-base text-brown-medium" data-id="element-91">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between bg-gold/5 rounded-xl p-4 border border-gold/20" data-id="element-92">
                <p className="font-body text-warm-gray line-through mb-2 sm:mb-0" data-id="element-93">
                  Valor real: $27 USD
                </p>
                <p className="font-heading text-xl font-bold text-gold" data-id="element-94">
                  Tu precio hoy: GRATIS
                </p>
              </div>
            </div>
          </motion.div>

          {/* BONO #2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="bg-cream rounded-2xl p-6 md:p-10 border border-gold/20 shadow-lg shadow-gold/5 relative overflow-hidden" data-id="element-95">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -z-0" data-id="element-96" />

            <div className="relative z-10" data-id="element-97">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 rounded-full mb-6" data-id="element-98">
                <GiftIcon className="w-5 h-5 text-gold" data-id="element-99" />
                <span className="text-sm font-bold text-gold font-body tracking-wider uppercase" data-id="element-100">
                  Bono #2
                </span>
              </div>

              <div className="flex items-start gap-4 mb-6" data-id="element-101">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-sm border border-gold/10" data-id="element-102">
                  <ClipboardIcon className="w-6 h-6 text-gold" data-id="element-103" />
                </div>
                <div data-id="element-104">
                  <h3 className="font-heading text-2xl font-bold text-brown-dark mb-2" data-id="element-105">
                    "Checklist Anti-Irritantes™"
                  </h3>
                  <p className="font-body text-lg font-medium text-sage-dark" data-id="element-106">
                    Lo que PAUSAR 7 días para que el picor baje (sin adivinar)
                  </p>
                </div>
              </div>

              {/* Image Mockup */}
              <div className="mb-8 flex justify-center" data-id="element-107">
                <img src="https://cdn.magicpatterns.com/uploads/7FjfQRW2hsivwFnjkZbLMy/n2.png" alt="Checklist Anti-Irritantes — Lo que pausar 7 días para que el picor baje" className="w-full max-w-xs rounded-xl shadow-md border border-gold/10" data-id="element-108" />
              </div>

              <div className="space-y-4 font-body text-base text-brown-medium leading-relaxed mb-8" data-id="element-109">
                <p data-id="element-110">Aquí hay una verdad que nadie te dice:</p>
                <p className="font-semibold text-brown-dark" data-id="element-111">
                  Antes de agregar algo que calme… hay que quitar lo que
                  enciende.
                </p>
                <p data-id="element-112">
                  Muchas rutinas fallan porque se siguen usando champús con
                  sulfatos agresivos, sprays con alcohol, aceites pesados en la
                  raíz…
                </p>
                <p data-id="element-113">…y después se pregunta por qué el picor no baja.</p>
                <p data-id="element-114">
                  Este bono te da la lista exacta de lo que pausar 7 días, cómo
                  leer ingredientes en 60 segundos (sin ser química) y qué
                  reemplazos suaves puedes usar mientras tanto.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gold/10 mb-8" data-id="element-115">
                <p className="font-heading text-lg font-bold text-brown-dark mb-4" data-id="element-116">
                  Lo que incluye:
                </p>
                <ul className="space-y-3" role="list" data-id="element-117">
                  {['Checklist de productos a pausar (9 categorías)', 'Checklist de hábitos que irritan (7 ajustes clave)', 'Tabla "Etiqueta-Radar": qué evitar y qué tolerar', 'Lista de reemplazos suaves (sin marcas)', 'Plan de reintroducción (semana 2) para encontrar al culpable', 'Plantilla "Mi baño en modo suave" (rellenable)'].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-118">
                      <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-119" />
                      <span className="font-body text-base text-brown-medium" data-id="element-120">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between bg-gold/5 rounded-xl p-4 border border-gold/20" data-id="element-121">
                <p className="font-body text-warm-gray line-through mb-2 sm:mb-0" data-id="element-122">
                  Valor real: $27 USD
                </p>
                <p className="font-heading text-xl font-bold text-gold" data-id="element-123">
                  Tu precio hoy: GRATIS
                </p>
              </div>
            </div>
          </motion.div>

          {/* BONO #3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="bg-cream rounded-2xl p-6 md:p-10 border border-gold/20 shadow-lg shadow-gold/5 relative overflow-hidden" data-id="element-124">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -z-0" data-id="element-125" />

            <div className="relative z-10" data-id="element-126">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 rounded-full mb-6" data-id="element-127">
                <GiftIcon className="w-5 h-5 text-gold" data-id="element-128" />
                <span className="text-sm font-bold text-gold font-body tracking-wider uppercase" data-id="element-129">
                  Bono #3
                </span>
              </div>

              <div className="flex items-start gap-4 mb-6" data-id="element-130">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-sm border border-gold/10" data-id="element-131">
                  <MessageIcon className="w-6 h-6 text-gold" data-id="element-132" />
                </div>
                <div data-id="element-133">
                  <h3 className="font-heading text-2xl font-bold text-brown-dark mb-2" data-id="element-134">
                    "Guión de 7 Días 'Estoy en Rescate'™"
                  </h3>
                  <p className="font-body text-lg font-medium text-sage-dark" data-id="element-135">
                    Mensajes + hábitos para no abandonar (y seguir el plan sin
                    improvisar)
                  </p>
                </div>
              </div>

              {/* Image Mockup */}
              <div className="mb-8 flex justify-center" data-id="element-136">
                <img src="https://cdn.magicpatterns.com/uploads/sxuZgpKky82bh19ozzML1a/hf_20260321_140633_a7bba87d-1077-4938-b4be-488a23a4f7d4.png" alt="Guión de 7 Días Estoy en Rescate — Mensajes y hábitos para no abandonar" className="w-full max-w-xs rounded-xl shadow-md border border-gold/10" data-id="element-137" />
              </div>

              <div className="space-y-4 font-body text-base text-brown-medium leading-relaxed mb-8" data-id="element-138">
                <p data-id="element-139">Este es el bono que más me enorgullece.</p>
                <p data-id="element-140">
                  Porque el problema real no es "no saber qué hacer". El
                  problema real es esto:
                </p>
                <p className="italic text-brown-dark" data-id="element-141">
                  Arrancas motivada el lunes. El martes el picor sube un poco y
                  entras en pánico. El miércoles improvisas algo nuevo. El
                  jueves abandonas.
                </p>
                <p data-id="element-142">
                  Y el viernes estás de vuelta en la farmacia, gastando dinero
                  en otro champú que no funciona.
                </p>
                <p className="font-semibold text-brown-dark" data-id="element-143">
                  Este guión corta ese ciclo.
                </p>
                <p data-id="element-144">
                  Te da 1 tarjeta por día con: el objetivo del día, la acción de
                  10 minutos, un script corto para mantener el foco y 3 checks
                  para saber que lo hiciste bien.
                </p>
                <p data-id="element-145">Sin drama. Sin largo. Sin excusas.</p>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gold/10 mb-8" data-id="element-146">
                <p className="font-heading text-lg font-bold text-brown-dark mb-4" data-id="element-147">
                  Lo que incluye:
                </p>
                <ul className="space-y-3" role="list" data-id="element-148">
                  {['7 tarjetas diarias (una por día, listas para usar)', '7 scripts de enfoque (copy/paste a tus notas)', 'Plan de recaída de 2 minutos (para retomar sin culpa)', 'Tracker diario de picor y caída', 'Señales de mejora por día (para no autosabotearte)', 'Guión ultra corto para los días difíciles'].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-149">
                      <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-150" />
                      <span className="font-body text-base text-brown-medium" data-id="element-151">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-between bg-gold/5 rounded-xl p-4 border border-gold/20" data-id="element-152">
                <p className="font-body text-warm-gray line-through mb-2 sm:mb-0" data-id="element-153">
                  Valor real: $27 USD
                </p>
                <p className="font-heading text-xl font-bold text-gold" data-id="element-154">
                  Tu precio hoy: GRATIS
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}